<template>
  <img class="filter" src="~@/assets/img/filter.png" @click="handleFilter" />
</template>

<script>
const orders = {
  // 升序
  1: 'ascending',
  // 降序
  2: 'descending',
  // 默认
  3: 'default'
}

export default {
  props: {
    sortProp: {
      type: String
    }
  },
  data() {
    return {
      count: 0
    }
  },
  methods: {
    handleFilter() {
      this.count++
      this.$emit('on-filter', {
        prop: this.sortProp,
        order: orders[this.count]
      })
      if (this.count > 2) {
        this.count = 0
      }
    }
  }
}
</script>

<style scoped>
.filter {
  width: 16px;
  height: 16px;
  margin-left: 7px;
  cursor: pointer;
}
</style>
